// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"DP-z","categoryName":"EP-z","categoryNameSearchHeader":"FP-z","categoryContent":"GP-z","bottomAligned":"HP-z","image":"IP-z","imageNoBackground":"JP-z"};